var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColossalSoftLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 924.24 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ColossalSoft_Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "249.12 343.83 104 488.96 249.12 488.96 249.12 343.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.01 505.37 266.72 598.66 266.72 675.01 398.19 543.54 360.01 505.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.12 672.12 249.12 506.56 192.21 506.56 192.23 604.49 249.12 672.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.67 312.54 369.67 484.97 554.57 484.97 554.57 312.54 462.12 404.97 369.67 312.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "652.15 190.03 462.12 0 272.08 190.03 462.12 380.08 652.15 190.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "673.41 343.83 673.41 488.96 818.54 488.96 673.41 343.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "730.32 506.56 673.41 506.56 673.41 672.13 730.29 604.49 730.32 506.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 626.66 209.01 835.68 247.18 797.51 76.33 626.66 0 626.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.7 949.38 453.32 1080 453.32 1003.64 360.87 911.21 322.7 949.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "847.9 626.66 677.06 797.51 715.22 835.68 924.24 626.66 847.9 626.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "524.78 670.13 470.92 616.27 470.92 793.87 613.99 936.93 652.15 898.76 524.75 771.35 524.78 670.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.49 771.35 272.08 898.76 310.25 936.93 453.32 793.87 453.32 616.27 399.47 670.13 399.49 771.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.92 1003.64 470.92 1080 601.53 949.38 563.37 911.21 470.92 1003.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.07 595.02 664.22 595.02 665.07 595.88 665.07 595.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525.19 544.4 655.8 675.01 655.8 598.67 563.37 506.22 525.2 544.4 525.19 544.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.68,
    y: 536.59,
    width: 53.99,
    height: 268.75,
    transform: "translate(-302.02 612.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.18,
    y: 643.96,
    width: 268.75,
    height: 53.99,
    transform: "translate(-376.16 433.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.12 502.57 462.12 582.26 542.12 502.57 382.12 502.57"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColossalSoftLogoBlack);
export default __webpack_public_path__ + "static/media/ColossalSoft_Logo__Black.912ea50dfd3689044526bded9a3207df.svg";
export { ForwardRef as ReactComponent };